import { MUTATION_TYPES } from './mutations';

export const actions = {
  setEvaluations({ commit }, evaluations) {
    commit(MUTATION_TYPES.SET_EVALUATIONS, evaluations);
  },

  setCurrentEvaluationId({ commit }, id) {
    commit(MUTATION_TYPES.SET_CURRENT_EVALUATION_ID, id);
  },
};
